export const getType = (value: unknown): string => {
  return value === null
    ? "null"
    : typeof value === "object"
      ? Array.isArray(value)
        ? "array"
        : "object"
      : typeof value;
};

export const valueToString = (value: unknown): string | undefined => {
  if (value === undefined) return undefined;
  return typeof value === "object" || typeof value === "boolean"
    ? JSON.stringify(value)
    : String(value);
};
